import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {LoadingService} from '../../services/loading/loading.service';
import {SweetAlertService} from '../../services/sweet-alert/sweet-alert.service';

@Component({
  selector: 'bw-loading-component',
  templateUrl: './loading-component.component.html',
  styleUrls: ['./loading-component.component.scss']
})
export class LoadingComponentComponent implements OnInit, OnDestroy {
  hideAnimate = true;
  showBlock = false;
  private subscription: Subscription;

  constructor (private loadingService: LoadingService, private sweetAlertService: SweetAlertService) {
  }

  ngOnInit () {
    this.subscription = this.loadingService.engineStatus.subscribe(status => {
      if (status === true) {
        this.showBlock = true;
      } else {
        this.showBlock = false;
      }
    });
  }

  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/components/loading-component/loading-component.component.ts